// Week and month video-playtime totals from a user's `activity` map
// (keys "YYYY-MM-DD" -> {totalVideoSeconds, ...}).
//
// "This week" is the ISO week (Monday through Sunday) containing `now`,
// matching how the reporting backend attributes playtime to the weekly
// CRM check-in rows (dayjs startOf("isoWeek")), so the number a learner
// sees here lines up with the week their case manager sees.
// "This month" is the calendar month containing `now`.

const toDateKey = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
    d.getDate(),
  ).padStart(2, "0")}`;

const getPlaytimeTotals = (activity, now = new Date()) => {
  const monday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  // getDay() is Sunday-based (0); shift so Monday starts the week.
  monday.setDate(monday.getDate() - ((monday.getDay() + 6) % 7));
  const sunday = new Date(monday);
  sunday.setDate(sunday.getDate() + 6);

  const weekStart = toDateKey(monday);
  const weekEnd = toDateKey(sunday);
  const monthStart = toDateKey(new Date(now.getFullYear(), now.getMonth(), 1));
  const monthEnd = toDateKey(
    new Date(now.getFullYear(), now.getMonth() + 1, 0),
  );

  const totals = {weekSeconds: 0, monthSeconds: 0};
  Object.entries(activity || {}).forEach(([date, day]) => {
    // Coerce in case DDB returns the attribute as a string.
    const secs = Number(day?.totalVideoSeconds) || 0;
    if (date >= weekStart && date <= weekEnd) totals.weekSeconds += secs;
    if (date >= monthStart && date <= monthEnd) totals.monthSeconds += secs;
  });
  return totals;
};

export default getPlaytimeTotals;
